import { useEffect } from 'react'

interface ThemeProviderProps {
  children: React.ReactNode
}

const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  useEffect(() => {
    const theme = window.location.origin.includes('happyexperts')
      ? 'happy-experts'
      : 'light'

    document.documentElement.setAttribute('data-theme', theme)
  }, [])

  return <>{children}</>
}
export default ThemeProvider
